module.exports = __webpack_public_path__ + "img/lancheng_bg.d350a125.png";